exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AddRemoveButton__addToWatchlist___1Q20D{background:#f0ad1c;width:auto;min-width:175px;height:19px;font-size:12px;font-weight:400;color:#fff;float:none;border-radius:0 0 5px 5px;margin-bottom:0;cursor:pointer;z-index:9999;transform:rotate(90deg);border:none;text-transform:uppercase;padding:8px 15px;box-sizing:content-box;position:fixed!important;right:-87px!important;top:468px}.AddRemoveButton__addToWatchlist___1Q20D:hover{background:#cd921c}.AddRemoveButton__addToWatchlist___1Q20D.AddRemoveButton__addToWatchlistPrivate___3VYUD{top:602px}.AddRemoveButton__addToWatchlistMobile___1WB0a{display:block;position:relative;float:right;background:transparent;margin-top:0;border:none;top:10px}.AddRemoveButton__addToWatchlistMobile___1WB0a:hover{background:transparent}.AddRemoveButton__addToWatchlistMobile___1WB0a svg{fill:#004f5c;vertical-align:top;width:40px;height:40px}", ""]);

// exports
exports.locals = {
	"addToWatchlist": "AddRemoveButton__addToWatchlist___1Q20D",
	"addToWatchlistPrivate": "AddRemoveButton__addToWatchlistPrivate___3VYUD",
	"addToWatchlistMobile": "AddRemoveButton__addToWatchlistMobile___1WB0a"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/Watchlist/AddRemoveButton.pcss
// module id = 938
// module chunks = 0